import {  institutionConstants, nameSpace } from "../constants/institution.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const postInstitution = (state = initialState, action) => {
 
  switch (action.type) {
    case institutionConstants[`POST_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case institutionConstants[`POST_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case institutionConstants[`POST_${nameSpace}_FAILURE`]:
        
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case institutionConstants[`POST_${nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
